import { BlogWrapper } from './style';

// Libs
import Translation from 'libs/Translation';

// Components
import Image from 'next/image';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Link from 'components/common/Link';
import Carousel from 'components/common/Carousel';
import PostItem from './PostItem'; 
import Container from 'components/common/Layout/Container';

const BlogPosts = ({ webConfig }) => {
    const posts = [
        { id: 0, link: 'https://vclinic.io/blog/%d8%b3%d9%84%d8%a7%d9%85%d8%aa-%d8%b1%d9%88%d8%a7%d9%86/', image: '/nextasset/images/home/blog1.png', title: Translation.t('title.blog1'), subtitle: Translation.t('label.desc.blog1') },
        { id: 1, link: 'https://vclinic.io/blog/%da%a9%d9%84%d8%a7%da%98%d9%86-%d8%af%d8%b1%db%8c%d8%a7%db%8c%db%8c-%da%86%db%8c%d8%b3%d8%aa%d8%9f/', image: '/nextasset/images/home/blog2.png', title: Translation.t('title.blog2'), subtitle: Translation.t('label.desc.blog2') },
        { id: 2, link: 'https://vclinic.io/blog/%d8%a8%d8%b1%d8%a7%db%8c-%d8%af%d8%a7%d8%b4%d8%aa%d9%86-%d8%af%d9%86%d8%af%d8%a7%d9%86-%d9%88-%d9%84%d8%ab%d9%87-%d8%b3%d8%a7%d9%84%d9%85-%da%86%d9%87-%da%a9%d8%a7%d8%b1%d9%87%d8%a7%db%8c%db%8c-%d8%a8/', image: '/nextasset/images/home/tooth.png', title: Translation.t('title.blog3'), subtitle: Translation.t('label.desc.blog3') }
    ]

    return (
        <BlogWrapper>
            <Container>
                <div className='wrapper'>
                    <div
                        className='row-flex'
                    >
                        <Image
                            src="/nextasset/images/home/heart.png"
                            width={57}
                            height={18}
                            alt="heart-icon"
                        />
                        <Link
                            to="https://vclinic.io/blog"
                            className="link"
                        >
                            {Translation.t('title.health-magazine')}
                            {webConfig.dir === 'ltr'
                            ?
                            <ArrowForwardIosIcon className='icon'/>
                            : 
                            <ArrowBackIosIcon className='icon'/>
                            }
                        </Link>
                    </div>

                    <div className='blog-posts'>
                    {posts.map(p => 
                        <PostItem 
                            key={p.id}
                            item={p}
                        />
                    )}
                    </div>
                    <div className='carousel'>
                        <Carousel
                            id="blog-posts"
                            arrow={false}
				            items={posts}
                            padding={true}
				            renderItem={item => <PostItem {...item} />}
			            />
                    </div>
                </div>
            </Container>
        </BlogWrapper>
    )
}
export default BlogPosts;